import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import bacteriaInformation from '../config/bacteria-information';
import animationSettings from '../config/animation-settings';
import {
    setActiveBacteria,
    showChooseABacteriaSection,
    setAnimationStage
} from '../actions';

import ThreeDModel from '../components/3d-model';
import Accordion from '../components/accordion';
import LineMap from '../components/line-map';
import BacteriaMedia from '../components/bacteria-media';
import Idler from '../components/idler';
import CloseButton from '../components/close-button';
import HelpButton from '../components/help-button';
import * as ReactGA from 'react-ga';

import rotateIcon from '../assets/images/360-icn.png';

class BacteriaPage extends Component {

    constructor(props){
        super(props);

        this._goBack = this._goBack.bind(this);
    }

    componentDidMount() {
        const { match: { params }, bacteria, goToBacteria, setVisitFromUrl } = this.props;
        const { name } = params;

        // User has visited directly via URL so no active bacteria is set.
        if(bacteria === null){
            const bacteriaArr = bacteriaInformation.filter( ( bacteria ) => { return bacteria.id === name; } );
            goToBacteria(bacteriaArr[0]);
            setVisitFromUrl();
        }

        if( bacteria !== null ) {
            ReactGA.pageview('/bacteria/' + name, null, 'Bacteria Page - ' + bacteria.name);
            ReactGA.event({
                category: 'Select a Bacteria',
                action: 'Bacteria Chosen',
                label: bacteria.name
            });
        }
    }

    _goBack() {
        const { goBack } = this.props;
        ReactGA.event({
           category: 'Bacteria',
           action: 'Page Closed'
        });
        goBack();
    }

    render() {
        const { bacteria } = this.props;

        if( bacteria !== null ){
            const { features } = bacteria;
            return(
                <div className="bacteria-page">
                    <Idler />
                    { bacteria.backgroundImage !== null &&
                        <div className="bacteria-page-video">
                            <img src={ bacteria.backgroundImage } />
                        </div>
                    }
                    <CloseButton />
                    <div className="bacteria-page-overlay" />
                    <div className="bacteria-page-model-container">
                        <div className="bacteria-page-model-main-circle" />
                        <div className="bacteria-page-model-inner-circle-1" />
                        <div className="bacteria-page-model-inner-circle-2" />
                        <div className="bacteria-page-model-inner-circle-3" />
                        <div className="bacteria-page-model-outer-circle-1" />
                        <div className="bacteria-page-model-outer-circle-2" />
                        <div className="bacteria-page-model">
                            <ThreeDModel bacteria={ bacteria }/>
                            <img src={ rotateIcon } alt="Rotate the model" />
                        </div>
                    </div>
                    <div className="bacteria-page-media-container">
                        <BacteriaMedia features={ bacteria.features }/>
                    </div>
                    <div className="bacteria-page-info-container">
                        <div className="bacteria-page-info-intro">
                            <h2>{ bacteria.name }</h2>
                            <p>{ bacteria.intro }</p>
                        </div>
                        { features !== undefined &&
                            <div className="bacteria-page-accordion-container">
                                <Accordion accordionItems={ features } />
                            </div>
                        }
                    </div>
                    <LineMap />
                </div>
            );
        }else{
            return null;
        }
    }

}

const mapStateToProps = ( state ) => {
    return {
        bacteria: state.activeBacteria,
        activeFeature: state.activeFeature
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return{
        goToBacteria: ( bacteria ) => {
            dispatch(setActiveBacteria(bacteria));
        },
        goBack: () => {
            dispatch(push( process.env.PUBLIC_URL + '/choose-a-bacteria' ) );
        },
        setVisitFromUrl: () => {
            dispatch( showChooseABacteriaSection() );
            dispatch( setAnimationStage( animationSettings.animationStages.length ) );
        }
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(BacteriaPage);



// WEBPACK FOOTER //
// ./src/pages/bacteria-page.js